import { merge } from 'lodash-es';
import {
  fileInputSchema,
  fileInputUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { VA_FORM_IDS } from 'platform/forms/constants';
import environment from 'platform/utilities/environment';
import { FILE_SIZE_MAX_BYTES, FILE_TYPES_ACCEPTED } from '../utils/constants';

const API_ENDPOINT = 'ivc_champva/v1/forms/submit_supporting_documents';
const FILE_UPLOAD_URL = `${environment.API_URL}/${API_ENDPOINT}`;

/**
 * Builds a configured fileInputUI component for submitting a single supporting document.
 *
 * @param {Object} [options={}] - Configuration options.
 * @param {string|null} [options.attachmentId=null] - Optional attachment identifier sent with the upload payload.
 * @param {boolean} [options.required=true] - Optional flag for marking the field as required.
 * @param {string|null} [options.hint=null] - Optional hint text for the field
 * @param {string} [options.title] - Input label displayed for the file field.
 
 * @returns {Object} A `fileInputUI` configuration object.
 */
export const attachmentUI = ({
  attachmentId = null,
  required = true,
  hint = null,
  title,
} = {}) => {
  const createPayload = (file, formId, password = null) => {
    const payload = new FormData();
    payload.append('file', file);
    payload.append('form_id', formId);
    if (attachmentId) payload.append('attachment_id', attachmentId);
    if (password) payload.append('password', password);
    return payload;
  };

  const parseResponse = ({ data }, file) => ({
    ...data.attributes,
    attachmentId,
    file,
  });

  return fileInputUI({
    accept: FILE_TYPES_ACCEPTED,
    fileUploadUrl: FILE_UPLOAD_URL,
    formNumber: VA_FORM_IDS.FORM_10_10D_EXTENDED,
    maxFileSize: FILE_SIZE_MAX_BYTES,
    createPayload,
    parseResponse,
    required,
    title,
    hint,
  });
};

export const attachmentSchema = Object.freeze(
  merge({}, fileInputSchema(), {
    properties: { attachmentId: { type: 'string' } },
  }),
);
